/// <reference types="vite/client" />
import { useEffect, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

const DEFAULT_PIPEFY_FORM_URL = 'https://app.pipefy.com/public/form/OvKw8-Ta'

/**
 * Incorpora o formulário público Pipefy num iframe.
 * Marca o documento com translate="no" e meta google notranslate para reduzir
 * a tradução automática do Chrome em páginas já em português (efeito varia por versão).
 */
export default function PipefyPublicFormEmbedPage() {
  const [searchParams] = useSearchParams()

  const formUrl = useMemo(() => {
    const fromQuery = searchParams.get('url')?.trim()
    if (fromQuery) {
      try {
        const u = new URL(fromQuery)
        if (u.protocol === 'https:' && u.hostname.endsWith('pipefy.com')) return u.toString()
      } catch {
        /* ignore */
      }
    }
    const envUrl = import.meta.env.VITE_PIPEFY_PUBLIC_FORM_URL?.trim()
    return envUrl || DEFAULT_PIPEFY_FORM_URL
  }, [searchParams])

  useEffect(() => {
    const html = document.documentElement
    html.setAttribute('translate', 'no')
    html.classList.add('notranslate')

    let meta = document.querySelector('meta[name="google"][content="notranslate"]')
    if (!meta) {
      meta = document.createElement('meta')
      meta.setAttribute('name', 'google')
      meta.setAttribute('content', 'notranslate')
      document.head.appendChild(meta)
    }

    return () => {
      html.removeAttribute('translate')
      html.classList.remove('notranslate')
      document.head.querySelector('meta[name="google"][content="notranslate"]')?.remove()
    }
  }, [])

  return (
    <div
      className="notranslate flex h-screen min-h-0 flex-col bg-background"
      translate="no"
    >
      <iframe
        title="Formulário público Pipefy"
        src={formUrl}
        className="min-h-0 w-full flex-1 border-0"
        allow="clipboard-write; fullscreen"
        referrerPolicy="strict-origin-when-cross-origin"
      />
    </div>
  )
}
